import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { MuiAppProvider } from "./theme/MuiAppProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <MuiAppProvider>
        <App />
      </MuiAppProvider>
    </ThemeProvider>
  </React.StrictMode>
);
